import { action, Action, Thunk, thunk } from "easy-peasy";
import { Injections } from "../../../store";
import { StoreModel } from "../..";
import { AttributesItem } from "../../../utils/preprocessing";
import { AttributeKeyValue } from "../AttributeKey";

export interface Operator {
  id: string;
  short_name: string;
  payment_externalized: boolean;
  host_name: string;
  attributes?: {
    items: AttributeKeyValue[];
    has_more: boolean;
    total: number;
  };
}

export interface UpdateOperatorOpts {
  attributes?: AttributesItem[];
}

export interface OperatorModel {
  operator: Operator | null;
  setOperator: Action<OperatorModel, Operator | null>;

  getOperator: Thunk<OperatorModel, null, Injections, StoreModel>;
  updateOperator: Thunk<
    OperatorModel,
    UpdateOperatorOpts,
    Injections,
    StoreModel
  >;
}

export const operatorModel: OperatorModel = {
  operator: null,

  setOperator: action((state, payload) => {
    state.operator = payload;
  }),

  getOperator: thunk(async (actions, payload, { injections }) => {
    const { operatorService } = injections;
    const response = await operatorService.getOperator();

    if (response.status === 200) {
      actions.setOperator(response.data);
    }

    return response.data;
  }),

  updateOperator: thunk(async (actions, payload, { injections }) => {
    const { operatorService } = injections;
    const response = await operatorService.updateOperator(payload);

    if (response.status === 200) {
      const operator = response.data;
      actions.setOperator(operator);
    }

    return response;
  }),
};
